import { isLargePayoutTrigger } from './EcddStructuredForm'

/**
 * Section list for ECDD detail left nav — ids must match `ecdd-section-{id}` anchors in ECDDDetail.
 */
export function buildEcddNavSections({ formAnswers, formGateEval, notesCount = 0 }) {
  const largePayout = isLargePayoutTrigger(formAnswers)
  const gateMap = Object.fromEntries((formGateEval?.gates || []).map((g) => [g.id, g]))
  const items = []
  let number = 1

  const gateStatus = (gateId) => {
    const g = gateMap[gateId]
    if (!g) return 'optional'
    return g.ok ? 'done' : 'required'
  }

  items.push({ id: 'context', number, title: 'Case context', status: 'info' })
  number += 1

  items.push({ id: 'trigger', number, title: 'Trigger', status: gateStatus('trigger') })
  number += 1

  if (!largePayout) {
    items.push({ id: 'kyc', number, title: 'KYC / identity', status: gateStatus('kyc') })
    number += 1
  }

  items.push({ id: 'sof', number, title: 'Source of funds / wealth', status: gateStatus('sof') })
  number += 1

  const actGate = gateMap.activity
  items.push({
    id: 'activity',
    number,
    title: 'Activity analysis',
    status: actGate ? (actGate.ok ? 'done' : 'required') : 'optional',
  })
  number += 1

  items.push({ id: 'engage', number, title: 'Patron engagement', status: gateStatus('engage') })
  number += 1

  items.push({ id: 'screen', number, title: 'Screening refresh', status: gateStatus('screen') })
  number += 1

  items.push({
    id: 'notes',
    number,
    title: 'General notes',
    status: 'optional',
    statusLabel: notesCount > 0 ? `${notesCount} note${notesCount !== 1 ? 's' : ''}` : null,
  })

  return items
}

export function scrollToEcddSection(sectionId) {
  const el = document.getElementById(`ecdd-section-${sectionId}`)
  if (!el) return

  const main = document.querySelector('#psg-main-content main')
  if (main) {
    const mainTop = main.getBoundingClientRect().top
    const elTop = el.getBoundingClientRect().top
    const offset = 24 // matches scroll-mt-24 on section anchors
    const top = elTop - mainTop + main.scrollTop - offset
    main.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
    return
  }

  el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

export function firstRequiredEcddSection({ formAnswers, formGateEval, notesCount = 0 }) {
  return buildEcddNavSections({ formAnswers, formGateEval, notesCount }).find((s) => s.status === 'required')
}
